import booleanGenerator from '../generators/boolean';

const booleanType = booleanGenerator;

export default booleanType;
